import {
  Box,
  IconButton,
  Stack,
  TextField,
  Tooltip
} from '@mui/material';
import { GridToolbarFilterButton } from '@mui/x-data-grid';
import { Close, Delete, Magnify, Refresh } from 'mdi-material-ui';
import toast from 'react-hot-toast';
import { apiService } from '../../api/axiosClient';


const CategoryToolbar = props => {
  const { numSelected, selected, setList, setReload } = props

  const UpdateCategory = () => {
    selected.forEach(async item => {
      try {
        await apiService.put(`/category/${item.id}`, {
          "level1": item.level1,
          "level2": item.level2,
          "level3": item.level3,
          "ca_order": item.ca_order,
          "ca_use": item.ca_use,
        })
        toast.success('수정 되었습니다')
      } catch (error) {
        console.error(error)
      }
    })
  }

  const DeleteCategory = () => {
    selected.forEach(async item => {
      try {
        await apiService.delete('/category', {
          data: {
            level: item.level,
            name: (() => {
              switch (item.level) {
                case 'l1':
                  return item.level1;
                case 'l2':
                  return item.level2;
                default:
                  return item.level3;
              }
            })()
          }
        })

        if (item.level === 'l1') {
          setList((items) => items.filter((k) => k.level1 !== item.level1));
        } else if (item.level === 'l2') {
          setList((items) => items.filter((k) => k.level2 !== item.level2));
        } else {
          setList((items) => items.filter((k) => k.id !== item.id));
        }

        toast.success('카테고리가 삭제되었습니다.')
        setReload(reload => reload + 1)

      } catch (error) {
        console.error(error)
      }
    })
  }

  return (
    <Box
      sx={{
        p: 2,
        pb: 0,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        justifyContent: 'space-between'
      }}
    >
      <Box>
        <GridToolbarFilterButton />
      </Box>
      <Box sx={{ display: 'flex' }}>
        {numSelected > 0 ? (
          <Stack direction="row" spacing={2} sx={{ pr: 4 }}>
            <Tooltip title='Update'>
              <IconButton sx={{ color: '#006A4E' }} onClick={UpdateCategory} >
                <Refresh />
              </IconButton>
            </Tooltip>
            <Tooltip title='Delete'>
              <IconButton sx={{ color: '#f44336' }} onClick={DeleteCategory} >
                <Delete />
              </IconButton>
            </Tooltip>
          </Stack>
        ) : null}

        <TextField
          variant='standard'
          value={props.value}
          onChange={props.onChange}
          placeholder='1차 카테고리 검색'
          InputProps={{
            startAdornment: <Magnify fontSize='small' />,
            endAdornment: (
              <IconButton size='small' title='Clear' aria-label='Clear' onClick={props.clearSearch}>
                <Close fontSize='small' />
              </IconButton>
            )
          }}
          sx={{
            width: {
              xs: 1,
              sm: 'auto'
            },
            m: theme => theme.spacing(1, 0.5, 1.5),
            '& .MuiSvgIcon-root': {
              mr: 0.5
            },
            '& .MuiInput-underline:before': {
              borderBottom: 1,
              borderColor: 'divider'
            }
          }}
        />
      </Box>

    </Box>
  )
}

export default CategoryToolbar
